module.exports = __webpack_public_path__ + "static/media/高分五号卫星.23e94d9b.png";